<template>
    <b-tabs card
            pills
            vertical
            nav-wrapper-class="w-40"
            v-model="tabs_sga.activo"
            no-key-nav
            lazy
    >
        <b-tab v-for="(componente, indice) in componentes"
               :key="indice"
               :title="componente.texto"
               class="border-0 sga-tabs"
               :title-item-class="(componente.visible ? '' : 'd-none') "
        >
            <component v-bind:is="componente.componente"
                       v-if="tabs_sga.activo === indice && componente.visible"
                       v-bind="componente.props" :ref="componente.ref"
            />
        </b-tab>
    </b-tabs>
</template>

<script>
import {mapState} from 'vuex';

import SgaCompleto from './sga/SgaCompleto.vue';
import FrasesSga from './sga/FrasesSga.vue';
import Hmis from './Hmis.vue';
import Nfpa from './Nfpa.vue';
import NacionesUnidas from './NacionesUnidas.vue';
import sgaTab from './sga';
import { getAcls, validarPermisoComponente, validarRol } from '../../../plugins/acl';

export default {
    name: 'SistemasClasificacion',
    props: {
        admin: {
            required: false
        },
        idEmpresa: {
            required: false
        },
        desactivar_edicion: {
            required: false
        },
        permissions: {
            required: false
        },
        isActionCreateWithIA: {
            required: false,
            default: false
        }
    },
    computed: {
        ...mapState('sga', [
            'tabs_sga',
            'selectedSga',
            'guardado'
        ]),
        ...mapState('autenticacion', [
            'usuarioAdmin',
            'usuarioEmpresa',
            'usuarioEmpresaHSE',
            'usuarioEmpresaContratista',
        ]),
        componentes() {
            let components = [
                {
                    texto: 'SGA',
                    componente: sgaTab,
                    visible: validarPermisoComponente('administracion-sga-producto'),
                    props: {
                        desactivar_edicion: this.desactivar_edicion,
                        isActionCreateWithIA: this.isActionCreateWithIA
                    },
                    ref: "tabSgaRef"
                },
                {
                    texto: 'SGA Completo',
                    componente: SgaCompleto,
                    visible: validarRol('empresa') || this.sgaDiligenciado || validarPermisoComponente('ver-sga-completo') || (this.permissions.includes('visualizar-informacion-sga-productos') && this.usuarioEmpresaContratista),
                    props: {
                        admin: this.usuarioAdmin
                    },
                    ref: "tabSgaCompletedRef"
                },
                {
                    texto: 'HMIS',
                    componente: Hmis,
                    visible: validarPermisoComponente('administracion-hmis-producto'),
                    props: {
                        desactivar_edicion: this.desactivar_edicion
                    },
                    ref: "tabSgaHmisRef"
                },
                {
                    texto: 'Naciones Unidas',
                    componente: NacionesUnidas,
                    visible: validarPermisoComponente('visualizar-naciones-unidas-productos'),
                    props: {
                        editarUN: validarPermisoComponente('administracion-naciones-unidas-producto'),
                        desactivar_edicion: this.desactivar_edicion,
                        isActionCreateWithIA: this.isActionCreateWithIA
                    },
                    ref: "sgaUNRef"
                },
                {
                    texto: 'Frases SGA',
                    key: 'frases_sga',
                    componente: FrasesSga,
                    visible: validarPermisoComponente('visualizar-frases-sga-productos'),
                    props: {
                        idEmpresa: this.idEmpresa,
                        desactivar_edicion: this.desactivar_edicion
                    },
                    ref: "tabSgaPhrasesRef"
                }
            ];

            if (this.isActionCreateWithIA) {
                components = components.filter(x => ['SGA', 'Naciones Unidas'].includes(x.texto));
            }

            return components;
        },
        sgaDiligenciado() {
            const sga = this.selectedSga;

            return this.guardado &&
                !!sga.categoriasfisicas.length &&
                !!sga.categoriassalud.length &&
                !!sga.categoriasambiental.length &&
                !!sga.categoriasNpeligrosas.length;
        }
    },
};
</script>

<style>
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
    color: #fff;
    background-color: #097b83;
}
</style>
